module.exports = __webpack_public_path__ + "img/33.054e5dac.jpg";